import { defineComponent } from 'vue';
import props from './props';
import { useTNodeJSX } from '../hooks/tnode';

export default defineComponent({
  name: 'TChatLoading',
  props: {
    movable: props.movable,
    animation: props.animation,
    textLoading: props.textLoading,
  },
  setup(props) {
    const renderTNodeJSX = useTNodeJSX();

    return () => {
      const textLoading = renderTNodeJSX('textLoading');
      return <div>加载动画</div>;
    };
  },
});
